{
    "quote": "Quote",
    "order": "Order",
    "order_info__1_title": "Customer",
    "order_info__1_item_title__customer_id": "Customer no.",
    "order_info__1_item_title__customer": "Customer",
    "order_info__1_item_title__sales_manager": "Sales Manager",
    "order_info__1_item_title__customer_contact": "Contact person",
    "order_info__1_item_title__po_number": "PO Number",
    "quote_info__2_title": "Quote configuration",
    "order_info__2_title": "Order configuration",
    "order_info__2_item_title__created_date": "Created date",
    "order_info__2_item_title__order_type": "Order Type",
    "order_info__2_item_title__collector": "Collector",
    "header_info_title": "Header",
    "header_info__sum_line_items": "Sum line items",
    "header_info__sum_incl_surcharges": "Sum incl. surcharges",
    "header_info__gross_margin": "GM",
    "header_info__gross_margin_percent": "GM %",
    "header_info__total_line": "Total Lines",
    "order_info__3_title": "Logistics",
    "order_info__3_item_title__warehouse": "Warehouse",
    "order_info__3_item_title__shipping_method": "Shipping Method",
    "order_info__3_item_title__service_provider": "Service provider",
    "order_info__3_item_title__delivery_address": "Delivery address",
    "order_info__3_item_title__billing_address": "Billing address",
    "order_info__3_item_title__order_desired_delivery_date": "Desired delivery date",
    "order_info__3_item_title__quote_due_date": "Due date",
    "tabs__details": "Details",
    "tabs__attachments": "PDF Attachments",
    "attachments__column_document": "Document",
    "attachments__column_date_added": "Date created",
    "attachments__column_type": "Type of document",
    "attachments__action_preview": "Preview",
    "attachments__action_download": "Download",
    "attachments__error_preview": "Failed to open document",
    "attachments__error_download": "Failed to download document"
}
